/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const ArrowArcRight = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            d="M8.802 14c.329 0 .596-.138.918-.433l4.944-4.851C14.918 8.482 15 8.22 15 8c0-.227-.082-.482-.336-.722L9.72 2.475C9.364 2.138 9.138 2 8.815 2 8.335 2 8 2.378 8 2.84V5h-.353C3.05 5.001 1 8.206 1 12.995c0 .647.336 1.005.713 1.005.301 0 .603-.09.836-.523 1.096-2.057 2.638-2.476 5.098-2.476H8v2.2c0 .462.336.799.802.799z"
            fill={vars.bdlGray50}
            fillRule="evenodd"
        />
    </AccessibleSVG>
);

export default ArrowArcRight;
